import { IntakeHelpPlansModel } from './intake-help-plans.model';

export class HelpPlanTypeModel{
    htyId: string; 
    htyCode: string;
    htyName: string;
    helpPlans: IntakeHelpPlansModel[]; 
}